module.exports = __webpack_public_path__ + "static/media/sensorcdt-logo.2c2c639f.jpg";